/**
 * Generic utility to repeatedly call a function. Similar to setInterval, but
 * with slightly different semantics.
 *
 * Repeatedly calls the given poll function with a delay between each call.
 * The poll function should return a promise. The next poll call will delay
 * until the returned promise is returned. Optional additional delay can be
 * implemented via the getDelay option (e.g., exponential backoff).
 *
 * @param {Object} obj
 * @param {Function} obj.poll Function that does the poll
 * @param {Function} obj.getDelay A function that is called to determine how
 * long to delay before the next poll. Called with the poll count.
 * @return {Function} Function to stop polling
 */
export var startPolling = function startPolling(_ref) {
  var poll = _ref.poll,
      getDelay = _ref.getDelay;
  var stopped = false;
  var timeoutId = null;

  var doPoll = function doPoll() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    timeoutId = setTimeout(function () {
      poll() // Poll again once complete, even if error
      ["catch"](function () {}).then(function () {
        return !stopped && doPoll(count + 1);
      });
    }, getDelay(count));
  };

  doPoll(); // Return function to stop polling

  var stopPolling = function stopPolling() {
    if (!stopped) {
      clearTimeout(timeoutId);
      timeoutId = null;
      stopped = true;
    }
  };

  return stopPolling;
};